export default "__VITE_ASSET__vJw8D0Dd__"